import React from 'react';
import ReactDOM from 'react-dom/client';
import {   BrowserRouter, Route } from "react-router-dom";
import { Routes } from './routes';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import 'bootstrap/dist/css/bootstrap.min.css';
import AddressBook from './pages/AddressBook';
import { AddressDetails } from './pages/AddressBook/addressDetails';
import AuthService from "./services/auth/auth.service"

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);



root.render(
  /*<React.StrictMode>*/
    <BrowserRouter>
      <Routes isAuthorized={AuthService.isAuth()} />
       
    </BrowserRouter>
  /*</React.StrictMode>*/
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
